import React from 'react';
import styles from './styles.module.scss';
import { LoaderInner, LoaderOuter } from '../../assets';

const DoubleCircleLoader = ({ className }) => {
  return (
    <div className={`${styles.doubleCircleWrapper} ${className}`}>
      <LoaderOuter className={styles.outerCircle} />
      <LoaderInner className={styles.innerCircle} />
    </div>
  );
};
export default DoubleCircleLoader;
